<template>
    <div>
        <header>
            <div class="top">
                <div class="banner">
                    <van-row>
                        <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                        </van-col>
                        <van-col span="12">
                            <div class="banner-title">{{ $t('selectCityApp.title') }}</div>
                        </van-col>
                    </van-row>
                </div>
                <div class="apply-box">
                    <div class="apply-value">
                        <van-field v-model="selectCity" @input="selectCityFun()" :placeholder="$t('selectCityApp.placeholder')"/>
                    </div>
                </div>
<!--                <div class="city-init">{{ $t('selectCityApp.current') }}</div>-->
<!--                <div class="current-city" @click="setCurrentCity(city)"><img class="current-icon" src="@/assets/theme/light/share/06selectCity/01map.png">{{city}}</div>-->
            </div>

        </header>
        <div class="select-city-box1">
            <div class="city-box" v-if="!showResult">
                <div v-for="(item, i) in cityList">
                    <div class="city-init" :id="'cap' + i">{{item.key}}</div>
                    <div class="city-ser-box">
                        <div class="city-item" v-for="c in item.list" @click="setCurrentCity(c)">{{c}}</div>
                    </div>
                </div>
            </div>
            <div class="city-box" v-if="showResult">
                <div v-for="(item, i) in resultList">
                    <div class="city-init" :id="'cap' + i">{{item.key}}</div>
                    <div class="city-ser-box">
                        <div class="city-item" v-for="c in item.list" @click="setCurrentCity(c)">{{c}}</div>
                    </div>
                </div>
            </div>
            <div class="right-box" v-if="!showResult">
                <div class="right-item" @click="selectCap(item.key, i)" v-for="(item, i) in cityList"
                     :style="{'height': capHeight + 'px'}">{{item.key}}
                </div>
            </div>

            <div class="right-box" v-if="showResult" :style="{'height': rightTop + 'px'}">
                <div class="right-item" @click="selectCap(item.key, i)" v-for="(item, i) in resultList"
                     :style="{'height': capHeight + 'px'}">{{item.key}}
                </div>
            </div>

            <div class="none-box" v-if="resultList.length == 0 && showResult">
                <van-icon class="none-icon" name="info-o"/>
                <div class="none-text">没有找到，换个词试试~</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pinyin from 'js-pinyin';
    import {Toast} from 'vant'
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'selectCity',
        data() {
            return {
                theme: 'light',
                city: '',
                showSelect: 0,
                selectCity: '',
                showResult: 0,
                orgList: [],
                cityList: [],
                resultList: [],
                capHeight: 20,
                rightTop: 161,
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme;
            }
            if(this.$route.query.currentCity) {
                this.city = this.$route.query.currentCity;
            }
            this.getCity();
            this.getCapHeight();
        },
        methods: {
            getCapHeight() {
                this.capHeight = (document.documentElement.clientHeight - 181) / 23;
            },
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            },
            getCity() {
                this.$api.share.getCity({
                    lang: this.$i18n.locale
                }).then(res => {
                    this.cityList = this.sortByFirstLetter(res.info);
                    this.orgList = res.info;
                })
            },
            sortByFirstLetter(origin) {
                // 将目标数据进行排序
                origin = origin.sort((pre, next) => Pinyin.getFullChars(pre).localeCompare(Pinyin.getFullChars(next)))
                const newArr = []
                origin.map(item => {
                    // 取首字母
                    const key = Pinyin.getFullChars(item).charAt(0)
                    const index = newArr.findIndex(subItem => subItem.key === key)
                    if (index < 0) {
                        newArr.push({
                            key: key,
                            list: [item]
                        })
                    } else {
                        newArr[index].list.push(item)
                    }
                })
                return newArr
            },
            selectCityFun() {
                let e = this.selectCity;
                if (e) {
                    this.showResult = 1;
                    let result = []
                    for (let i = 0; i < this.orgList.length; i++) {
                        if (this.orgList[i].indexOf(e) != -1) {
                            result.push(this.orgList[i]);
                        }
                    }
                    this.resultList = this.sortByFirstLetter(result);
                } else {
                    this.showResult = 0
                }

            },
            selectCap(key, i) {
                key = '\n \n' + key + '\n \n \n'
                Toast({
                    getContainer: '#app',
                    message: key,
                });
                // offsetTop距离上方或上层控件的位置
                let clientWidth = document.documentElement.clientWidth;
                let ratio = clientWidth / 375;
                let top = 267 * ratio;
                let h = document.getElementById('cap' + i).offsetTop - top;
                // scrollTop滚动到指定位置
                document.body.scrollTop = h;
                document.documentElement.scrollTop = h;
                // 解决ios兼容问题
                // let u = navigator.userAgent;
                // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
                // if (!isAndroid) {
                //     window.scrollBy(0, h);
                // }
            },
            switchSelct() {
                this.showSelect = !this.showSelect;
            },
            setCurrentCity(c) {
                WebJSBridge.call("selectCity", {
                    'selectedCity': c
                }, function (res) {
                });
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            }
        }
    }
</script>

<style scoped>
    .apply-box {
        margin-top: 15px;
    }

    .apply-value {
        width: 345px;
        height: 44px;
        margin: 0 auto;
        background: var(--bg-color-1);
        opacity: 1;
        border-radius: 6px;
        position: relative;
    }

    /deep/ input {
        background-color: transparent;
        color: var(--text-color-1);
        font-size: 15px;
        caret-color: #20D38F;
    }

    /deep/ input::-webkit-input-placeholder {
        color: var(--text-color-3);
        opacity: 0.6;
    }

    /deep/ input::-moz-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ input:-moz-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ input::-ms-input-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ .van-cell {
        background-color: var(--bg-color-2) !important;
        border-radius: 10px;
    }

    .select-city-box1 {
        margin-top: 180px;
        height: 667px;
    }

    .select-city-box2 {
        margin-top: 165px;
    }

    .city-box {
        width: 100%;
        height: calc(100% - 155px);
    }

    .city-ser-box {
        background-color: var(--bg-color-2);
        border-radius: 13px;
        width: 345px;
        margin:  0 auto;
    }

    .search {
        float: right;
        margin-top: 10px;
        margin-right: 16px;
        font-size: 24px;
    }

    .current-city {
        width: 345px;
        height: 46px;
        background: var(--bg-color-2);
        border-radius: 10px 10px 10px 10px;
        margin: 0 auto;
        color: var(--text-color-1);
        font-size: 15px;
        display: flex;
        align-items: center;
    }

    .current-icon {
        width: 20px;
        margin: 0 12px 0 20px;
    }

    .city-init {
        color: var(--text-color-1);
        font-size: 17px;
        margin:  20px 0 12px 15px;
    }

    .city-item {
        width: 347px;
        height: 41px;
        text-align: left;
        font-size: 15px;
        padding-left: 28px;
        line-height: 41px;
        color: var(--text-color-1);
    }

    .top {
        background: var(--bg-color-1);
        padding-bottom: 20px;
    }

    .right-box {
        position: fixed;
        height: calc(100% - 181px);
        right: 0px;
        color: #A3A3A3;
        font-size: 15px;
        top: 161px;
        z-index: 1111;
        -webkit-transform: translateZ(0);
    }

    .right-item {
        padding-left: 40px;
        width: 20px;
        text-align: left;
        padding-right: 10px;
    }

    .result-right {
        top: 170px
    }

    .none-box {
        text-align: center;
        margin-top: 30px;
    }

    .none-icon {
        font-size: 30px;
        color: #707070;
    }

    .none-text {
        font-size: 15px;
        margin-top: 10px;
        opacity: 0.9;
    }

    .city-ser-box .city-item:first-child {
        padding-top: 10px;
    }

    .city-ser-box .city-item:last-child {
        padding-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/my/04selectCity.vue